module.exports = __webpack_public_path__ + "img/cassetta-sicurezza-chiavi-grande-capacita.d98166a8.png";